module.exports = __webpack_public_path__ + "img/keshavarzi-card-image.0a512995.png";